import { httpPublic } from "@/api/httpPublic";

export const trackingRequests = {
  email: function ({ context, data } = {}) {
    return httpPublic.post("/v1/tracking/email", { context, json: data }).json();
  },
};
